import { Transform } from 'class-transformer';
import { IsNumber, IsOptional, IsString } from 'class-validator';

export class DailyTemperaturePointDto {
  @IsString()
  date!: string;

  @IsNumber()
  @Transform(({ value }) => Number(value))
  min!: number;

  @IsNumber()
  @Transform(({ value }) => Number(value))
  max!: number;

  @IsNumber()
  @Transform(({ value }) => Number(value))
  avg!: number;

  @IsNumber()
  @Transform(({ value }) => Number(value))
  count!: number;

  @IsOptional()
  @IsNumber()
  @Transform(({ value }) => Number(value))
  humidityMin?: number;

  @IsOptional()
  @IsNumber()
  @Transform(({ value }) => Number(value))
  humidityMax?: number;

  @IsOptional()
  @IsNumber()
  @Transform(({ value }) => Number(value))
  humidityAvg?: number;

  @IsOptional()
  @IsNumber()
  @Transform(({ value }) => Number(value))
  humidityCount?: number;
}

export class IntradayTemperaturePointDto {
  @IsString()
  timestamp!: string;

  @IsNumber()
  @Transform(({ value }) => Number(value))
  temperature!: number;

  @IsOptional()
  @IsNumber()
  @Transform(({ value }) => Number(value))
  humidity?: number;
}

/** Raw relative-humidity sample returned by the humidity chart view. */
export class IntradayHumidityPointDto {
  @IsString()
  timestamp!: string;

  @IsNumber()
  @Transform(({ value }) => Number(value))
  humidity!: number;
}
